import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineSummaryGetAsyncSlice } from './get';

export const coreTimelineSummaryReducers = combineReducers({
	get: coreTimelineSummaryGetAsyncSlice.asyncReducers
});

export const coreTimelineSummaryWatchers = combineAllWatchers([ coreTimelineSummaryGetAsyncSlice.asyncWatchers ]);
